import React, { FunctionComponent } from "react";
import styles from "./ImageBlock.module.scss";
import ImageBlockProps from "./ImageBlockProps.interface";

import combineClasses from "helpers/combine-classes";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import getImageCrop from "app/media/helpers/getImageCrop";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import ImageViewer from "components/ImageViewer/ImageViewer";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";
import BackgroundMedia from "components/BackgroundMedia/BackgroundMedia";
import useSplitBackground from "blocks/hooks/useSplitBackground";
import useAnchor from "blocks/hooks/useAnchor";

const ImageBlock: FunctionComponent<ImageBlockProps> = (props): JSX.Element => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const wrapperStyles = useWrapperStyles(props.settings);

    const identifier = useAnchor(props.settings.anchorMenuLabel);
    const { splitClasses, splitStyles } = useSplitBackground(props);

    const imageCrop = getImageCrop(props.content.image?.umbracoFile.crops, props.settings.imageCrop, "Fullscreen (4:3)");
    const imageAspectRatio = getImageAspectRatio(imageCrop, props.content.image?.umbracoWidth, props.content.image?.umbracoHeight);
    const imageSizeClass = props.settings.imageSize ? styles[props.settings.imageSize] : undefined;
    const imageFit = props.settings.imageFit === "Contain" ? "contain" : "cover";

    return (
        <section className={combineClasses(styles.wrapper, imageSizeClass, ...wrapperClasses)} style={{ ...wrapperStyles, ...splitStyles }} id={identifier}>
            <div className={combineClasses(styles.container, ...splitClasses, imageSizeClass)}>
                <div className={styles.media}>
                    {/* Media */}
                    {props.content.image ? (
                        <ImageViewer key={props.contentUdi} src={props.content.image.umbracoFile.src} type={imageFit} extensionType={props.content.image.umbracoExtension} crop={imageCrop} focalPoint={props.content.image.umbracoFile.focalPoint} alt={props.content.imageAlternative} aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} sourceWidth={props.content.image?.umbracoWidth} sourceHeight={props.content.image?.umbracoHeight} />
                    ) : null}

                    {/* Caption */}
                    {props.content.imageCaption && props.content.imageCaption.length > 0 ? (
                        <div className={styles.caption}>{props.content.imageCaption}</div>
                    ) : null}
                </div>
            </div>

            {props.settings.backgroundMedia?.[0] && props.settings.backgroundMedia.length > 0 ? (
                <BackgroundMedia key={props.contentUdi} {...props.settings.backgroundMedia[0]} />
            ) : null}
        </section>
    );
};

export default ImageBlock;